import { useEffect, useState } from "react";

type Storage = {
  contract: string;
  measured_at: string;
  scope: string;
  complete: boolean;
  scanned_entries: number;
  filesystem: { capacity_bytes:number; free_bytes:number; used_bytes:number } | null;
  categories: Record<string,number|null>;
  counts:{release_directories_measured:number;retained_release_minimum:number;incomplete_build_directories:number;older_incomplete_build_directories:number};
  review_only:{older_incomplete_builds_bytes:number;minimum_age_hours:number;warning:string};
  warnings:string[];
  protections:string;
};
const fmt=(bytes:number|null|undefined) => bytes===null||bytes===undefined||!Number.isFinite(bytes)
  ? "unavailable" : bytes<1024 ? `${bytes} B` : `${(bytes/1024**(bytes>=1024**3?3:bytes>=1024**2?2:1)).toFixed(1)} ${bytes>=1024**3?"GiB":bytes>=1024**2?"MiB":"KiB"}`;
const LABELS:Record<string,string> = {
  active_release_bytes:"Active public Release",
  other_protected_releases_bytes:"Other protected recent Releases",
  older_releases_bytes:"Other immutable Releases (NOT disposable by default)",
  incomplete_release_builds_bytes:"Incomplete Release build directories",
  unknown_release_files_bytes:"Unclassified files in Release storage",
  other_public_volume_bytes:"Other public-volume data",
  private_media_bytes:"Private media and attachments",
  database_logical_bytes:"PostgreSQL logical database size (not additive with filesystem totals)"
};
export function StorageHealth() {
  const [data,setData] = useState<Storage|null>(null);
  const [error,setError] = useState("");
  const [busy,setBusy] = useState(false);
  const load = async (refresh:boolean) => {
    setBusy(true);setError("");
    try {
      const response=await fetch(`/api/health/storage${refresh?"?refresh=true":""}`,{credentials:"same-origin",cache:"no-store"});
      if(!response.ok)throw Error(`Storage inspection unavailable (HTTP ${response.status})`);
      setData(await response.json());
    } catch(e) {setError(e instanceof Error?e.message:String(e));}
    finally {setBusy(false);}
  };
  useEffect(()=>{void load(false);},[]);
  return <section className="panel" aria-label="Storage inventory" aria-busy={busy}>
    <h2>Project storage · read-only</h2>
    <p className="muted">Measures paths visible to the Control container. Host backup archives and other Docker volumes are not included. Nothing can be deleted here.</p>
    <div className="actions"><button type="button" className="subtle" disabled={busy} onClick={()=>void load(true)}>Refresh disk inventory</button></div>
    {error&&<p className="alert" role="alert">{error}</p>}
    {data&&<>
      <p className="muted">Measured {new Date(data.measured_at).toLocaleString()} · {data.scanned_entries} filesystem entries · {data.complete?"complete within mounted scope":"partial measurement"}</p>
      <dl>{Object.entries(data.categories).map(([key,value])=><div key={key}><dt>{LABELS[key]??key}</dt><dd>{fmt(value)}</dd></div>)}</dl>
      {data.filesystem&&<p>Underlying filesystem: {fmt(data.filesystem.used_bytes)} used · {fmt(data.filesystem.free_bytes)} available. This is not all Digging Beagle data.</p>}
      <p>Measured Release directories: {data.counts.release_directories_measured}. Keep at least the newest {data.counts.retained_release_minimum}, plus the active Release.</p>
      <p>Older incomplete build directories (2h+): {data.counts.older_incomplete_build_directories}, {fmt(data.review_only.older_incomplete_builds_bytes)} for manual review only.</p>
      <p className="muted">{data.review_only.warning} {data.protections}</p>
      {data.warnings.map((warning,i)=><p className="alert" key={i}>{warning}</p>)}
    </>}
  </section>;
}
